import { Component } from '@angular/core';

@Component({
  selector: 'bor-standards',
  standalone: false,
  templateUrl: './standards.component.html',
  styleUrl: './standards.component.scss',
})
export class StandardsComponent {}
